import React, { ChangeEvent } from "react";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AgentFormState } from "../../../types/agentTypes";
import AgentLegalForm from "../../../enum/AgentLegalForm.enum";
import Provider from "../../../enum/Provider.enum";
import { FieldColumn, FieldRow, Section, SectionTitle } from "../styles";

type DocumentsSectionProps = {
  formData: AgentFormState;
  setFormData: React.Dispatch<React.SetStateAction<AgentFormState>>;
  provider: Provider;
  onChange: (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>,
  ) => void;
};

const DocumentsSection = ({
  formData,
  setFormData,
  provider,
  onChange,
}: DocumentsSectionProps) => {
  const { t } = useTranslation();

  const isInnRequired = provider !== Provider.BELARUS;

  return (
    <Section>
      <SectionTitle>{t("createAgent.documents.title")}</SectionTitle>

      <FieldRow>
        {formData.format === AgentLegalForm.COMPANY && (
          <FieldColumn>
            <TextField
              size="small"
              label={t("createAgent.documents.okato")}
              name="okato"
              value={formData.okato ?? ""}
              fullWidth
              onChange={onChange}
            />
          </FieldColumn>
        )}

        <FieldColumn>
          <TextField
            size="small"
            label={t("createAgent.documents.inn")}
            name="inn"
            value={formData.inn ?? ""}
            fullWidth
            required={isInnRequired}
            onChange={(event: ChangeEvent<HTMLInputElement>) => {
              const value = event.target.value;
              const numbersOnly = value.replace(/\D/g, "");

              setFormData((prev) => ({
                ...prev,
                inn: numbersOnly,
              }));
            }}
          />
        </FieldColumn>
      </FieldRow>
    </Section>
  );
};

export default DocumentsSection;